import React from 'react';

export const MenuContainer: React.FC = (props) => (
  <div
    className="flex flex-col bg-white rounded-lg ring-2 ring-primary-60 shadow-md my-2 overflow-auto max-h-56"
    {...props}
  />
);
